import React from 'react'
import CounterPage from './pages/CounterPage'

const App = () => {
  return (
    <CounterPage/>
  )
}

export default App;